"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AttachmentPreferencesFull_1 = require("./components/AttachmentPreferencesFull");
var isAttachmentPreferencesOptionDirty_1 = require("./utils/isAttachmentPreferencesOptionDirty");
var discardAttachmentPreferencesOption_1 = require("./actions/discardAttachmentPreferencesOption");
var saveAttachmentPreferencesOption_1 = require("./actions/saveAttachmentPreferencesOption");
var AttachmentPreferencesOption = {
    key: 'attachmentPreferences',
    titleStringKey: 'optionTitle_attachmentPreferences',
    searchTermsStringKey: 'optionTitle_attachmentPreferences',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AttachmentPreferencesFull_1.default, null); },
        isDirty: isAttachmentPreferencesOptionDirty_1.default,
        onSave: saveAttachmentPreferencesOption_1.default,
        onDiscard: discardAttachmentPreferencesOption_1.default,
    },
};
exports.default = AttachmentPreferencesOption;
//# sourceMappingURL=AttachmentPreferencesOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/AttachmentPreferencesOption.js
// module id = 4979
// module chunks = 2